import { useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CurrencyCircleDollar, House, SquaresFour, Wallet } from '@phosphor-icons/react';

import { paths } from '../../routes/paths';

import { WizardDoneStep } from '../../components/wizard';
import { useOnboardingFooter } from '../../hooks/useOnboardingFooter';
import { authAPI } from '../../data/auth';
import pt from '../../locales/pt';
import { useAuth } from '../../store/AuthContext';

function firstName(fullName, fallback = 'Amigo') {
  const trimmed = (fullName || '').trim();
  if (!trimmed) return fallback;
  return trimmed.split(/\s+/)[0];
}

export function OnboardingReady() {
  const navigate = useNavigate();
  const { profile, refreshMe } = useAuth();
  const [loading, setLoading] = useState(false);

  const displayName = useMemo(
    () => firstName(profile?.full_name),
    [profile?.full_name],
  );

  const onFinish = useCallback(async () => {
    setLoading(true);
    await authAPI.saveOnboardingStep('completed', true);
    await refreshMe();
    setLoading(false);
    navigate(`${paths.dashboard}?openGuidedFlow=1`);
  }, [navigate, refreshMe]);

  useOnboardingFooter({
    primaryLabel: pt.onboarding.ready.cta,
    primaryIcon: House,
    onPrimary: onFinish,
    loading,
  });

  // .pen `Onboarding · Pronto`: cada pill do resumo tem um link «Editar» que
  // devolve o utilizador ao passo correspondente do onboarding.
  const summary = useMemo(
    () => [
      {
        label: pt.onboarding.ready.pillSources,
        icon: CurrencyCircleDollar,
        editTo: '/onboarding/income-sources',
      },
      {
        label: pt.onboarding.ready.pillCategories,
        icon: SquaresFour,
        editTo: '/onboarding/categories',
      },
      {
        label: pt.onboarding.ready.pillAssets,
        icon: Wallet,
        editTo: '/onboarding/accounts',
      },
    ],
    [],
  );

  return (
    <WizardDoneStep
      title={pt.onboarding.ready.title.replace('{name}', displayName)}
      subtitle={pt.onboarding.ready.subtitle}
      summary={summary}
      nextTip={pt.onboarding.ready.nextBody}
    />
  );
}
